import React from "react";
import CajaVacia from "./CajaVacia";
import FormularioContacto from "./FormularioContacto";

export default function Contacto() {
    return (

            <div className="contenedor-principal">
                <section id={"aventura-en-seismiles"}>
                    <CajaVacia
                        encabezado={"Me quiero contactar con ustedes"}
                        titulo={"¿Listos para tu próxima aventura?"}
                        descripcion={
                            "Escribinos y te ayudamos a elegir la expedición ideal."
                        }
                        boton={""}
                    />
                    {/*<div className="contenedor-imagenes"></div>*/}
                </section>
                <div>
                    <FormularioContacto
                        nombre={"Contacto"}
                        icono={"cuna"}

                    />
                </div>
                <form className="form-reservas">
                    <input type="text" placeholder="Nombre y apellido" />
                    <input type="tel" placeholder="WhatsApp" />
                    <input type="email" placeholder="Email" />
                    <textarea placeholder="Contanos qué tipo de salida querés hacer"></textarea>
                    <button className={"boton-enfasis"} type="submit">Enviar consulta</button>
                </form>
            </div>

    );
}